let config={
    baseApi:process.env.VUE_APP_API,
    alreadyTest:"0",
    waitTest:"0"
};
export default config;
